import React, { MouseEventHandler, forwardRef } from "react";

export interface ButtonProps {
  children:  React.ReactElement | null | any;
  variant?: "primary" | "secondary" | "neutral" | "error" | "success" | "info";
  size?: "small" | "default" | "large" | "xlarge";
  full?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  [key: string]: any;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = "primary",
      size = "default",
      full = false,
      onClick,
      ...rest
    },
    ref
  ) => {
    const getPadding = () => {
      if (size === "small") {
        return "px-2 py-1 text-sm";
      } else if (size === "large") {
        return "px-6 py-3 text-lg";
      } else if (size === "xlarge") {
        return "px-12 py-4 text-xl";
      }
      return "px-4 py-2 text-base";
    };

    const getVariantClasses = () => {
      switch (variant) {
        case "secondary":
          return "bg-gray-200 text-gray-700 hover:bg-gray-300";
        case "neutral":
          return "bg-gray-300 text-gray-700 hover:bg-gray-400";
        case "error":
          return "bg-red-500 text-white hover:bg-red-600";
        case "success":
          return "bg-green-500 text-white hover:bg-green-600";
        case "info":
          return "bg-blue-500 text-white hover:bg-blue-600";
        default:
          return "bg-primary text-white";
      }
    };

    const buttonClasses = `disabled:opacity-75 inline-flex items-center justify-center rounded-full shadow-card font-bold focus:outline-none ${getPadding()} ${getVariantClasses()} ${
      full ? "w-full" : ""
    }`;

    return (
      <button ref={ref} className={buttonClasses} onClick={onClick} {...rest}>
        {children}
      </button>
    );
  }
);

export default Button;
